






















































import { Component, Vue } from 'vue-property-decorator';
import gql from 'graphql-tag';
import { isFullCountPatch } from '@/app/WarehousePatch';
import { GQL_warehousePatchList_currentUnit_warehousePatches } from '@/queries/__generated__/warehousePatchList';

const WAREHOUSE_PATCH_LIST = gql`
  query warehousePatchList {
    currentUnit {
      id
      warehousePatches {
        id
        date
        supplierUnit {
          id
          name
        }
        warehousePatchLines {
          id
          checkpoint
        }
      }
    }
  },
`;

@Component
export default class WarehousePatchList extends Vue {
  private WAREHOUSE_PATCH_LIST = WAREHOUSE_PATCH_LIST;

  // A patch is listed as a full count only when every line is one; any
  // other patch is an ordinary one, with or without a supplier.
  private supplierColumn(item: GQL_warehousePatchList_currentUnit_warehousePatches): string {
    if (item.supplierUnit) return item.supplierUnit.name;
    if (isFullCountPatch(item.warehousePatchLines)) return this.$t('WarehousePatch.checkpointPatch').toString();
    return this.$t('WarehousePatch.noSupplier').toString();
  }
}
